module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Donna Leon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Donna Leon")]), _vm._v(" is the author of the internationally bestselling Commissario Guido Brunetti Mystery series. The winner of the CWA Macallan Silver Dagger for Fiction, among other awards, Leon was born in New Jersey and has lived in Venice for thirty years.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/9Lu2Rs/tc-custom/9780802195623.jpg?1728259387579",
      "alt": "This image is the cover for the book Drawing Conclusions, A Commissario Guido Brunetti Mystery"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Drawing Conclusions, A Commissario Guido Brunetti Mystery\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“A brilliant writer . . . an immensely likable police detective who takes every murder to heart.” —Marilyn Stasio, "), _c('i', [_vm._v("The New York Times Book Review")])]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Late one night, Guido Brunetti is called away from dinner to investigate the death of a widow in her modest apartment. Though there are some signs of a struggle, the medical examiner rules that she died of a heart attack. It seems there is nothing for Brunetti to investigate."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" But he can’t shake the feeling that something or someone may have triggered her heart attack, that perhaps the woman was threatened. Conversations with the woman’s son, her upstairs neighbor, and the nun in charge of the old age home where she volunteered do little to satisfy Brunetti’s nagging curiosity. And with the help of Inspector Vianello and the ever-resourceful Signorina Elettra, he intends to get to the truth."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “One of her best . . . She has become a must-read for all those who favor character-driven crime stories.” —"), _c('i', [_vm._v("Booklist")]), _vm._v(", starred review"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “[A] wickedly entertaining series.” —"), _c('i', [_vm._v("Publishers Weekly")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grove press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0